export default {
  data(){
    return {
      updateFields: [
        'type',
        'uploadData',
      ],
      detailPageRouteName: 'imagesDetail',
    }
  },
  computed: {
    typeOptions() {
      return Object.keys(this.constraints).map(key => ({
        id: key,
        text: this.getTypeText(key)
      }));
    }
  },
  methods: {
    getTypeText(type){
      switch(type){
        case 'profile_images':
          return this.$gettext('Profilový obrázek');
        default:
          return this.$gettext('Neznámý typ');
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/views/images/mixins/images.js